import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { EmbedWebcastService } from 'rev-shared/embed/EmbedWebcast.Service';
import { ISessionKeepalive, SessionService } from 'rev-shared/security/Session.Service';
import { IWebcastViewContext } from 'rev-shared/webcast/webcastView/IWebcastViewContext';

import { WebcastModel } from 'rev-portal/scheduledEvents/webcast/model/WebcastModel';
import { INotifications } from 'rev-portal/scheduledEvents/webcast/Webcast.Contract';
import { VBrickPlayerComponent, VideogularComponent } from '@vbrick/vbrick-player';

@Component({
	selector: 'embed-webcast',
	templateUrl: './EmbedWebcast.Component.html',
	standalone: false
})
export class EmbedWebcastComponent implements OnInit, OnDestroy {
	@Input() public accountId: string;
	@Input() public params: any;
	@Input() public sidebarNotifications: INotifications;
	@Input() public webcastId: string;
	@Input() public webcast: WebcastModel;
	@Input() public analyticsViewContext: string;

	private sub: Subscription;
	private keepalive: ISessionKeepalive;

	public webcastViewContext: IWebcastViewContext;
	constructor(
		private readonly EmbedWebcastService: EmbedWebcastService,
		private readonly SessionService: SessionService
	) { }

	public ngOnInit(): void {
		this.webcastViewContext = this.getWebcastViewContext(this.params?.enableFullRev);
		this.sub = this.EmbedWebcastService.start(this.webcast).subscribe();
		this.keepalive = this.SessionService.createKeepalive().beginWhenConnected();
	}

	public ngOnDestroy(): void {
		this.sub?.unsubscribe();
		this.keepalive?.end();
	}

	public onPlayerReady(player: VBrickPlayerComponent, vgAPI: VideogularComponent): void {
		this.sub.add(this.EmbedWebcastService.handlePlayerEvents(player, vgAPI).subscribe());
	}

	private getWebcastViewContext(enableFullRev: boolean): IWebcastViewContext {
		return {
			infoSidebar: {},
			showNavBar: false,
			hideFullscreenPresentation: true,
			showPresentationSlides: enableFullRev,
			hideSidebar: !enableFullRev,
			focusVideo: !enableFullRev
		};
	}
}
